import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Paso1Login } from 'src/app/global/interfaces/paso-1-login';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { LocalStorageServiceVM } from 'src/app/view-model/services/localstorage.service';
import { environment } from '../../../../../environments/environment';
import { Paso0 } from '../../../interfaces/paso-0';
import { Paso1 } from '../../../interfaces/paso-1';
import { Paso2 } from '../../../interfaces/paso-2';


const env = environment;

@Injectable()
export class LocalStorageProvider extends LocalStorageService {

  private paso_0: Paso0;
  private paso_1: Paso1;
  private paso_1_login: Paso1Login;
  private paso_2: Paso2;
  private current_page: string;
  private paso_3: Paso3;
  private paso_0_key: string = _.get(env, 'localStorage.PASO_0', '');
  private paso_1_key: string = _.get(env, 'localStorage.PASO_1', '');
  private paso_2_key: string = _.get(env, 'localStorage.PASO_2', '');
  private paso_3_key: string = _.get(env, 'localStorage.PASO_3', '');
  private current_page_key: string = _.get(env, 'localStorage.CURRENT_PAGE', '');

  constructor(private _localStorage: LocalStorageServiceVM) {
    super();
  }

  getCurrentPage(): string {
    this.current_page = this._localStorage.getData(this.current_page_key);
    return this.current_page;
  }

  setCurrentPage(page: string): void {
    this._localStorage.setData(this.current_page_key, page);
  }

  getPaso0(): Paso0 {
    this.paso_0 = this._localStorage.getData(this.paso_0_key, false) as Paso0;
    return this.paso_0;
  }
  setPaso0(data: Paso0): void {
    this._localStorage.setData(this.paso_0_key, data, false);
  }

  getPaso1(): Paso1 {
    this.paso_1 = this._localStorage.getData(this.paso_1_key, false) as Paso1;
    return this.paso_1;
  }

  setPaso1(data: Paso1): void {
    this._localStorage.setData(this.paso_1_key, data, false);
  }

  getPaso1Login(): Paso1Login {
    this.paso_1_login = this._localStorage.getData(this.paso_1_key, false) as Paso1Login;
    return this.paso_1_login;
  }
  setPaso1Login(data: Paso1Login): void {
    this._localStorage.setData(this.paso_1_key, data, false);
  }

  getPaso2(): Paso2 {
    this.paso_2 = this._localStorage.getData(this.paso_2_key) as Paso2;
    return this.paso_2;
  }
  setPaso2(data: Paso2): void {
    this._localStorage.setData(this.paso_2_key, data);
  }

  addPaso2(data: Paso2): void {
    this._localStorage.addData(this.paso_2_key, data);
  }

  resertApp() {
    this._localStorage.clearData();
  }

  getPaso3() {
    this.paso_3 = this._localStorage.getData(this.paso_3_key) as Paso3;
    return this.paso_3;
  }

  setPaso3(data: Paso3) {
    this._localStorage.setData(this.paso_3_key, data);
  }

}
